import { connect } from 'react-redux';
import { requestBrandOptions, saveSearchPreferences } from '../modules/tour';

import HotelSearchPrefs from './HotelSearchPrefs';

const mapDispatchToProps = {
  requestBrandOptions,
  saveSearchPreferences,
};

const mapStateToProps = state => ({
  brandList: state.tours.brands,
});

export default connect(mapStateToProps, mapDispatchToProps)(HotelSearchPrefs);



// WEBPACK FOOTER //
// src/routes/tours/components/HotelSearchPrefsContainer.js